module.exports = __webpack_public_path__ + "img/image154.7e1e2def.jpg";